var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconProposals(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 33 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    transform: "translate(-.617)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M13.479.364c.435-.424 1.117-.463 1.597-.116l.138.116 15.075 14.672c.439.427.475 1.098.11 1.566l-.11.122-5.807 5.786h-9.024L3.948 11.328c-.44-.427-.476-1.098-.11-1.566l.11-.122 9.53-9.276zm.867 1.257l-9.108 8.865L16.072 21h7.778l5.152-5.114L14.346 1.621z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 1.667,
    x: 0.617,
    y: 21,
    rx: 0.833
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M16.33 14.69l13.396 2.596.563-.58c.479-.465.479-1.22 0-1.686L15.244.363c-.478-.465-1.253-.465-1.731 0l-.545.53 2.57 13.009c.08.399.392.71.791.788z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProposals);
export default __webpack_public_path__ + "static/media/icon-proposals.f1a28ebb.svg";
export { ForwardRef as ReactComponent };